const EventObjectClassEnum = Object.freeze({
    ADVISER: 'ADVISER',
    INVESTOR: 'INVESTOR',
    PROPOSAL: 'PROPOSAL',
    SHORTLIST: 'SHORTLIST'
});

export default EventObjectClassEnum;
